/* eslint-disable react-hooks/exhaustive-deps */
import { zodResolver } from '@hookform/resolvers/zod';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { Control, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { z } from 'zod';
import { INotfis } from '../../../interfaces/response/Notfis/INotfisResponse';
import { ObterPedidos } from '../../../redux/features/orders/ordersThunk';
import { useAsyncDispatch } from '../../../redux/store';
import { formatarData } from '../../../util/format';

interface IProps {
  loading: boolean;
  pedidos: INotfis[];
  control: Control<FormSchema>;
  startDate: Date | undefined;
  endDate: Date | undefined;
  consultarPedidos: () => Promise<void>;
}

export interface IMessageProps {
  mensagem: string;
  show: boolean;
  type: 'success' | 'error';
}

const formSchema = z.object({
  startDate: z.date().optional(),
  endDate: z.date().optional(),
});

type FormSchema = z.infer<typeof formSchema>;

const useListNotfis = (): IProps => {
  const dispatch = useAsyncDispatch();
  const [pedidos, setPedidos] = useState<INotfis[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const dateAux = new Date();
  const { control, watch } = useForm<FormSchema>({
    resolver: zodResolver(formSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      endDate: new Date(),
      startDate: new Date(dateAux.setDate(dateAux.getDate() - 1)),
    },
  });
  const { startDate, endDate } = watch();

  const consultarPedidos = async (): Promise<void> => {
    setLoading(true);

    await dispatch(
      ObterPedidos({
        dataInicio: formatarData(startDate, true, 'input') ?? '',
        dataFim: formatarData(endDate, true, 'input') ?? '',
      })
    )
      .unwrap()
      .then((response) => {
        console.log(response);

        setPedidos(response.listaNotfis);
      })
      .catch((error) => {
        const axiosError = error as AxiosError;
        if (axiosError.code === 'ERR_CANCELED') return;

        console.log(error);
        toast.error('Ocorreu um erro ao consultar os pedidos');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    consultarPedidos();
  }, [startDate, endDate]);

  return {
    pedidos,
    loading,
    control,
    endDate,
    startDate,
    consultarPedidos,
  };
};

export default useListNotfis;
